module.exports = __webpack_public_path__ + "static/banner-img-mobile-opt1-2a1563a044e6378c2f5c18c16140472d.jpg";